/* eslint-disable react-hooks/exhaustive-deps */
import { LicenseInfo } from '@mui/x-data-grid-premium';
import { useEffect } from 'react';
import { Routes2 } from './router';
import { CssBaseline } from 'src/components';
import { useSnackbar } from "notistack";
import SnackbarUtils from 'src/utils/SnackbarUtils';
import CustomThemeProvider from './theme/ThemeProvider';
// import SessionExpirationTime from './utils/SessionExpirationTime';
import { useAppDispatch, useAppSelector } from "./store";
import { ConfirmationServiceProvider } from "./base/ConfirmationDialog/ConfirmationService";
import { SidebarSlice } from './layouts/contexts/SidebarSlice';
import { useLocation } from 'react-router';
import { useGetKullaniciVarsayilanListQuery } from './services/Base/GnlKullaniciVarsayilanApi';

const App = () => {
  const userInfo = useAppSelector(s => s.userLogin.userInfo);
  const sidebar = useAppSelector(s => s.sidebar);
  const menuSlice = useAppSelector((state) => state.menuAuth);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  useEffect(() => {
    SnackbarUtils.setSnackBar(enqueueSnackbar, closeSnackbar)
  }, [enqueueSnackbar, closeSnackbar]);

  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

  const { organizasyon } = useAppSelector(state => state.userOrganizasyon);
  const kullaniciVarsayilanQuery = useGetKullaniciVarsayilanListQuery(userInfo?.id, { skip: (organizasyon?.fkOrganizasyon > 0 && userInfo?.id > 0) ? false : true });
  useEffect(() => {
    if (organizasyon?.fkOrganizasyon > 0) {
      if (!kullaniciVarsayilanQuery.isFetching && typeof kullaniciVarsayilanQuery?.data !== "undefined") {
        const kontrol = kullaniciVarsayilanQuery.data?.find((f) => f.ekranAd === "USERBOX" && f.kontrolad === "UB_MENUAYAR");
        if (kontrol?.deger === "H")
          return;
      }
      if (location.pathname !== "/duyuru") {

        const bul = menuSlice.data.find((f) => f?.link === location?.pathname);
        if (!bul)
          return;
        if (bul.link === sidebar.link)
          return;
        dispatch(SidebarSlice.actions.setLink(location?.pathname));
        dispatch(SidebarSlice.actions.setDesktopOpen(!sidebar.desktopOpen));
        dispatch(SidebarSlice.actions.setMobileOpen(!sidebar.mobileOpen));
      }
    }
  }, [location.pathname, kullaniciVarsayilanQuery.isFetching]);

  window.onkeydown = (ev: KeyboardEvent) => {
    if (ev.code === "F5" && process.env.NODE_ENV === "production")
      ev.preventDefault();
  }
  return (
    <CustomThemeProvider>
      <CssBaseline />
      {/* #TODO: KULLANICILARI LOGOUTA DÜŞÜRÜYORMU KONTROLÜ İLE KALDIRILDI */}
      {/* <SessionExpirationTime /> */}
      <ConfirmationServiceProvider>
        <Routes2 bolumSecildi={organizasyon.fkOrganizasyon > 0}></Routes2>
      </ConfirmationServiceProvider>
    </CustomThemeProvider>
  );
};
export default App;
